import { createSelector } from 'reselect'

import { getApiWebsocketNotifications } from '../api/selectors'
import { getCurrentMemberId } from '../current/selectors'

export const getNotificationsForCurrentMember = createSelector(
  [getApiWebsocketNotifications, getCurrentMemberId],
  (notifications, currentMemberId) => {
    return Object.values(notifications).filter((notification) => {
      return notification.member_id === parseInt(currentMemberId, 10)
    }, {})
  },
)
